import { defineMessages } from 'react-intl';

export default defineMessages({
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    },
    preferences: {
        id: 'header.links.preferences',
        defaultMessage: 'Preferences'
    },
    onlinePaymentApp_AX: {
        id: 'header.links.OnlinePaymentApp_AX',
        defaultMessage: 'Claim online payments'
    },
    serviceRequests: {
        id: 'header.app.serviceRequests_AX',
        defaultMessage: 'Service Requests'
    },
    createService: {
        id: 'header.app.createService_AX',
        defaultMessage: 'New service'
    },
    fnol: {
        id: 'header.app.fnol_AX',
        defaultMessage: 'New claim'
    }
});
